<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  methods: {
  },
  created() {
    this.$store.dispatch('fetchMobileCreatives');
    this.$store.dispatch('fetchDesktopCreatives');
  },
};

</script>

<style lang="stylus">
body
  position absolute
  left 0
  top 0
  margin 0
  padding 0
  background-color #f5f7fa
  width 100%
  height 100%

#app
  font-family 'Roboto', Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  width 100%
  height 100%
  position absolute
  left 0
  top 0
  font-size 0
</style>
